import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useRouteMatch, useHistory } from 'react-router-dom'

import withStyles from '@material-ui/core/styles/withStyles'
import { Breadcrumb } from 'react-breadcrumbs'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { PageTitle } from 'Components/PageTitle'
import { LinkEdit } from 'Components/Link/Edit'
import { ButtonDeleteInline } from 'Components/Buttons/ButtonDeleteInline'
import SubmitButton from 'Components/Form/SubmitButton'
import SimpleTableTable from 'Components/SimpleTableTable'
import Pagination from 'Components/FilterAndPaginationComponent/Pagination'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { SearchInput } from 'Components/Header/SearchInput'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import { showReduxModal } from 'Reducers/UI/actions'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'
import { deleteTagsGQL, getTagsGQL } from './gql'
import { styles } from './styles'
import { TAG_TYPE_ENUM } from '../../../shared/constants'

const resultsPerPage = 50

const BreadcrumbsTagsManagement = ({ className, currentPath }) => {
  return (
    <div className={className}>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Tags Management',
          pathname: currentPath,
        }}
      />
    </div>
  )
}

const TagsManagementTable = ({ classes }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()
  const [tagsData, setTagsData] = useState({ tags: [], totalCount: 0 })
  const [offsetRecordsStart, setOffsetRecordsStart] = useState(0)
  const [searchString, setSearchString] = useState('')
  const [type, setType] = useState(null)
  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getTagsGQL,
    defaultFetchArgs: {
      offset: offsetRecordsStart,
      first: resultsPerPage,
    },
  })

  useEffect(() => {
    refetch({
      offset: offsetRecordsStart,
      first: resultsPerPage,
      value: searchString,
      type,
    })
  }, [offsetRecordsStart, resultsPerPage, searchString, type])

  useEffect(() => {
    if (isLoaded)
      setTagsData({
        tags: data.getTags.edges.map(item => item.node),
        totalCount: data.getTags.totalCount,
      })
  }, [isLoaded])

  const redirectAddTag = () => history.push(`${match.url}/create`)

  const header = ['Tag Name', 'Type', 'Actions']

  const rows = tagsData.tags.map(tag => {
    return {
      id: tag.id,
      'Tag Name': tag.value,
      'Type': tag.type,
    }
  })

  const onDeleteClick = async tagId =>
    dispatch(
      showReduxModal({
        title: 'Confirmation needed',
        onConfirm: async () => {
          await deleteTagsGQL({ id: tagId })
          refetch({ offset: offsetRecordsStart, first: resultsPerPage })
        },
        children: `Are you sure you want to remove this tag?`,
      }),
    )

  const onOffsetChange = offset => {
    if (offset < 0) offset = 0
    if (offset > tagsData.totalCount) return

    setOffsetRecordsStart(offset)
  }

  const onChangeTypeHandler = (e, index, value) => setType(value)

  const postRowRender = tag => {
    const editUrl = `${match.url}/edit/${tag.id}`
    return {
      ...tag,
      'Actions': (
        <div className={classes.actionButtons}>
          <React.Fragment>
            <LinkEdit to={editUrl} />
            <ButtonDeleteInline onClickHandler={() => onDeleteClick(tag.id)} />
          </React.Fragment>
        </div>
      ),
    }
  }

  return (
    <React.Fragment>
      <BreadcrumbsTagsManagement
        currentPath={match.url}
        className={classes.header}
      />
      <PageTitle className={classes.header}>Tags management</PageTitle>
      <p className={classes.description}>
        Manage all tags that can be later assigned to different entities. Like
        'Client'
      </p>
      <div className={classes.tableWrapper}>
        <SubmitButton
          className={classes.createButton}
          value="ADD TAG"
          onClick={redirectAddTag}
        />
        <LayoutDashboard>
          <FiltersWrapper style={{ maxWidth: '50%' }}>
            <FilterBox>
              <SearchInput
                placeholder="Search tag"
                searchHandler={setSearchString}
                value={searchString}
              />
            </FilterBox>
            <FilterBox>
              <FilterSelect
                hasPrimaryText={false}
                label="Type"
                onChange={onChangeTypeHandler}
                options={Object.keys(TAG_TYPE_ENUM).map(item => ({
                  label: item,
                  value: item,
                }))}
                value={type}
                sorted={false}
              />
            </FilterBox>
          </FiltersWrapper>
        </LayoutDashboard>
        <SimpleTableTable
          header={header}
          data={rows}
          postRowRender={postRowRender}
          showPages={false}
        />
        <div className={classes.pagination}>
          <Pagination
            total={tagsData.totalCount || rows.length}
            offset={offsetRecordsStart || 0}
            resultsPerPage={resultsPerPage || rows.length}
            onOffsetChange={onOffsetChange}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default withStyles(styles)(TagsManagementTable)



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/index.js